import React, { useCallback, useEffect, useState } from 'react';
import { Tabs } from 'antd';
import { WhatsAppOutlined, FileTextOutlined } from '@ant-design/icons';
import WhatsappTemplates from './Templates';
import api from '../../services/api';
import WhatsappNumbers from './Numbers';
import { PageIntro, PageLayout, PagePanel } from '../../components';

interface IWhatsappConfig {
  id: string;
  tenantId: string;
  phoneNumberId: string;
  wabaId: string;
  status?: string;
  name?: string;
}

const WhatsappConnections: React.FC = () => {
  const [configs, setConfigs] = useState<IWhatsappConfig[]>([]);
  const [currentConfig, setCurrentConfig] = useState<IWhatsappConfig | null>(
    null,
  );
  const [loading, setLoading] = useState<boolean>(false);

  const list = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get('/whatsapp/config');
      const data = Array.isArray(response.data)
        ? response.data
        : response.data.data || [];
      setConfigs(data as IWhatsappConfig[]);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    list();
  }, []);

  return (
    <PageLayout>
      <PageIntro
        badge="Conexões"
        icon={<WhatsAppOutlined />}
        title="WhatsApp Business API"
        description="Gerencie números, templates e integrações oficiais da Meta em uma estrutura visual alinhada ao restante do sistema."
      />
      <PagePanel>
        <Tabs
          type="card"
          items={[
            {
              label: (
                <>
                  <WhatsAppOutlined /> Números
                </>
              ),
              key: '1',
              children: <WhatsappNumbers />,
            },
            {
              label: (
                <>
                  <FileTextOutlined /> Templates
                </>
              ),
              key: '2',
              children: <WhatsappTemplates />,
            },
          ]}
        />
      </PagePanel>
    </PageLayout>
  );
};

export default WhatsappConnections;
